enum notificationConstants {
    ADD = "notification/ADD",
    REMOVE = "notification/REMOVE",
    CLEAR_TOASTS = "notification/CLEAR_TOASTS"
}

export default notificationConstants;
